import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface GradientTextProps extends TypographyProps {
  gradient?: 'primary' | 'secondary' | 'accent' | 'animated';
  underline?: 'none' | 'hover' | 'always';
}

const StyledTypography = styled(Typography)<GradientTextProps>(({ theme, gradient, underline }) => {
  let backgroundImage;
  
  switch (gradient) {
    case 'primary':
      backgroundImage = 'linear-gradient(90deg, #8A2BE2, #00CC99)';
      break;
    case 'secondary':
      backgroundImage = 'linear-gradient(90deg, #8A2BE2, #FF6F00)';
      break;
    case 'accent':
      backgroundImage = 'linear-gradient(90deg, #FF6F00, #003366)';
      break;
    case 'animated':
      backgroundImage = 'linear-gradient(90deg, #003366, #00CC99, #8A2BE2, #FF6F00)';
      break;
    default:
      backgroundImage = 'linear-gradient(90deg, #8A2BE2, #00CC99)';
  }
  
  return {
    backgroundImage,
    backgroundSize: gradient === 'animated' ? '300% 100%' : '100% 100%',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    display: 'inline-block',
    ...(gradient === 'animated' && {
      animation: 'gradientAnimation 3s ease infinite',
      '@keyframes gradientAnimation': {
        '0%': {
          backgroundPosition: '0% 50%',
        },
        '50%': {
          backgroundPosition: '100% 50%',
        },
        '100%': {
          backgroundPosition: '0% 50%',
        },
      },
    }),
    ...(underline === 'always' && {
      textDecoration: 'underline',
      textDecorationColor: gradient === 'primary' ? '#00CC99' : 
                           gradient === 'secondary' ? '#FF6F00' : 
                           gradient === 'accent' ? '#003366' : '#8A2BE2',
      textUnderlineOffset: '4px',
    }),
    ...(underline === 'hover' && {
      '&:hover': {
        textDecoration: 'underline',
        textDecorationColor: gradient === 'primary' ? '#00CC99' : 
                             gradient === 'secondary' ? '#FF6F00' : 
                             gradient === 'accent' ? '#003366' : '#8A2BE2',
        textUnderlineOffset: '4px',
        cursor: 'pointer',
      }
    }),
  };
});

const GradientText: React.FC<GradientTextProps> = ({ 
  gradient = 'primary', 
  underline = 'none',
  children, 
  ...props 
}) => {
  return (
    <StyledTypography gradient={gradient} underline={underline} {...props}>
      {children}
    </StyledTypography>
  );
};

export default GradientText;